module.exports = __webpack_public_path__ + "static/media/5.9584f4c6.png";